import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Filter } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { CrmTabs } from "@/features/crm/crm-tabs";
import { SegmentBuilder } from "@/features/crm/segment-builder";

function CrmSegmentsPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="6xl">
      <PageHeader
        title={t(msg`Segments`)}
        description={t(msg`Dynamic audiences for campaigns`)}
        icon={Filter}
        backTo="/crm"
      />
      <div class="mt-4">
        <CrmTabs />
        <SegmentBuilder />
      </div>
    </PageContainer>
  );
}

export const crmSegmentsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/crm/segments",
  component: withFeatureGate("crm.leads", CrmSegmentsPage),
});
